export const colors = {
  cream50: 'rgba(252, 252, 249, 1)',
  cream100: 'rgba(255, 255, 253, 1)',
  slate500: 'rgba(98, 108, 113, 1)',
  slate900: 'rgba(19, 52, 59, 1)',
  teal500: 'rgba(33, 128, 141, 1)',
  teal600: 'rgba(29, 116, 128, 1)',
  teal700: 'rgba(26, 104, 115, 1)',
  red500: 'rgba(192, 21, 47, 1)',
  orange400: 'rgba(230, 129, 97, 1)',
  orange500: 'rgba(168, 75, 47, 1)',
  gray300: 'rgba(167, 169, 169, 1)',
  gray400: 'rgba(119, 124, 124, 1)',
  brown600: 'rgba(94, 82, 64, 1)',
  green500: 'rgba(34, 197, 94, 1)'
};

export const wardCategories = {
  premium: {
    price: 5000,
    nursing: 1500,
    equipment: 1000,
    name: 'Premium Ward',
    category: '₹5,000 Premium'
  },
  semi_premium: {
    price: 3000,
    nursing: 1000,
    equipment: 600,
    name: 'Semi-Premium Ward',
    category: '₹3,000 Semi-Premium'
  },
  normal: {
    price: 1200,
    nursing: 400,
    equipment: 200,
    name: 'Normal Ward',
    category: '₹1,200 Normal'
  },
  icu: {
    price: 8000,
    nursing: 2000,
    equipment: 3000,
    name: 'ICU Ward',
    category: '₹8,000 ICU'
  }
};

export const availableEquipment = [
  'Oxygen', 'Monitor', 'IV Stand', 'Ventilator', 
  'Defibrillator', 'TV', 'Recliner', 'Mini Fridge'
];

export const initialWardData = {
  general_ward_a: {
    name: 'General Ward A',
    type: 'normal',
    totalBeds: 20,
    floor: '1',
    department: 'General Medicine',
    layout: [
      ['A1', 'A2', 'A3', 'A4', 'A5'],
      ['A6', 'A7', 'A8', 'A9', 'A10'],
      ['A11', 'A12', 'A13', 'A14', 'A15'],
      ['A16', 'A17', 'A18', 'A19', 'A20']
    ],
    initialState: {
      A1: { 
        status: 'occupied', 
        patient: 'Ramesh Kumar', 
        doctor: 'Dr. Mehta', 
        admissionDate: '2025-10-20', 
        contact: '9876543210',
        type: 'normal',
        floor: '1',
        equipment: ['Oxygen', 'Monitor'],
        notes: 'Regular monitoring required'
      },
      A5: { 
        status: 'occupied', 
        patient: 'Priya Singh', 
        doctor: 'Dr. Singh', 
        admissionDate: '2025-10-21', 
        contact: '9876543211',
        type: 'normal',
        floor: '1',
        equipment: ['Monitor'],
        notes: ''
      },
      A12: { 
        status: 'occupied', 
        patient: 'Amit Sharma', 
        doctor: 'Dr. Kumar', 
        admissionDate: '2025-10-19', 
        contact: '9876543212',
        type: 'normal',
        floor: '1',
        equipment: ['Oxygen'],
        notes: ''
      },
      A18: { 
        status: 'maintenance',
        type: 'normal',
        floor: '1',
        equipment: [],
        notes: 'Bed frame repair needed',
        maintenanceSchedule: '2025-10-24'
      },
      A19: { 
        status: 'reserved',
        type: 'normal',
        floor: '1',
        equipment: ['Oxygen', 'Monitor', 'IV Stand'],
        notes: 'Reserved for surgery patient'
      }
    }
  },
  icu_ward: {
    name: 'ICU Ward',
    type: 'icu',
    totalBeds: 12,
    floor: '2',
    department: 'Intensive Care',
    layout: [
      ['ICU1', 'ICU2', 'ICU3', 'ICU4'],
      ['ICU5', 'ICU6', 'ICU7', 'ICU8'],
      ['ICU9', 'ICU10', 'ICU11', 'ICU12']
    ],
    initialState: {
      ICU1: { 
        status: 'occupied', 
        patient: 'Rajesh Patel', 
        doctor: 'Dr. Gupta', 
        admissionDate: '2025-10-22', 
        contact: '9876543213',
        type: 'icu',
        floor: '2',
        equipment: ['Ventilator', 'Monitor', 'IV Stand', 'Oxygen'],
        notes: 'Critical condition, 24/7 monitoring'
      },
      ICU4: { 
        status: 'occupied', 
        patient: 'Sunita Devi', 
        doctor: 'Dr. Jain', 
        admissionDate: '2025-10-21', 
        contact: '9876543214',
        type: 'icu',
        floor: '2',
        equipment: ['Monitor', 'Oxygen', 'IV Stand'],
        notes: 'Post-surgery recovery'
      },
      ICU7: { 
        status: 'occupied', 
        patient: 'Vikram Reddy', 
        doctor: 'Dr. Mehta', 
        admissionDate: '2025-10-20', 
        contact: '9876543215',
        type: 'icu',
        floor: '2',
        equipment: ['Ventilator', 'Monitor', 'IV Stand', 'Oxygen', 'Defibrillator'],
        notes: 'Cardiac monitoring required'
      },
      ICU9: { 
        status: 'occupied', 
        patient: 'Kavita Nair', 
        doctor: 'Dr. Singh', 
        admissionDate: '2025-10-23', 
        contact: '9876543216',
        type: 'icu',
        floor: '2',
        equipment: ['Monitor', 'Oxygen', 'IV Stand'],
        notes: ''
      }
    }
  },
  premium_ward: {
    name: 'Premium Ward',
    type: 'premium',
    totalBeds: 8,
    floor: '3',
    department: 'VIP',
    layout: [
      ['P1', 'P2', 'P3', 'P4'],
      ['P5', 'P6', 'P7', 'P8']
    ],
    initialState: {
      P2: { 
        status: 'occupied', 
        patient: 'Anil Kapoor', 
        doctor: 'Dr. Kumar', 
        admissionDate: '2025-10-22', 
        contact: '9876543217',
        type: 'premium',
        floor: '3',
        equipment: ['Monitor', 'Oxygen', 'TV', 'Recliner'],
        notes: 'VIP patient - special dietary requirements'
      },
      P6: { 
        status: 'reserved',
        type: 'premium',
        floor: '3',
        equipment: ['Monitor', 'Oxygen', 'TV', 'Recliner', 'Mini Fridge'],
        notes: 'Reserved for corporate executive'
      }
    }
  }
};
